import GroupLayout from "./GroupLayout";

const VishwakarmaLayout = () => (
  <GroupLayout
    brandName="Vishwakarma"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/vishwakarma-university-vu-logo.png"
    groupId="20000000008"
    headline="Vishwakarma Group of Institutions"
  />
);

export default VishwakarmaLayout;
